// used for displaying the prep, cook, and total time for a recipe
// e.g. `90` (minutes) becomes `1 hour and 30 minutes`

export default function formatMinutes(totalMinutes) {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  let result = "";
  
  if (hours > 0) {
    result += `${hours} hour${hours > 1 ? 's' : ''}`;
  }
  
  if (minutes > 0) {
    if (result) result += ', '; // Separate hours and minutes with a comma
    result += `${minutes} minute${minutes > 1 ? 's' : ''}`;
  }

  return result
}